// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_zRU","cls2":"ArticlesFilters-cls2_Ppc ArticlesFilters-cls1_zRU"};